/** Traductions modal saisie code (FR / AR) */
export const codeEntryModalFr = {
  errCodeRequired: 'Veuillez entrer un code',
  errInvalidCode: 'Code invalide',
  errUnlockCodeRequired: 'Veuillez entrer le code de déverrouillage',
  errBusinessId: 'Impossible de déterminer l\'ID de l\'entreprise',
  successUnlock: 'Verrouillage annulé avec succès',
  errInvalidUnlockCode: 'Code de déverrouillage invalide',
  errUnlockValidation: 'Erreur lors de la validation du code de déverrouillage',
  lockoutTitle: 'SYSTÈME VERROUILLÉ',
  lockoutMessage: 'Le système a été verrouillé en raison de plusieurs tentatives de connexion échouées',
  timeRemaining: 'Temps restant',
  failedAttempts: '{{count}} tentatives échouées détectées',
  emergencyUnlockTitle: 'Code de Déverrouillage d\'Urgence',
  emergencyUnlockHint: 'Si vous avez un code de déverrouillage d\'urgence, vous pouvez l\'utiliser pour annuler le verrouillage',
  enterEmergencyCode: 'Entrer le Code d\'Urgence',
  emergencyCodePlaceholder: 'Entrez le code d\'urgence',
  validating: 'Validation...',
  unlockBtn: 'Déverrouiller',
  cancel: 'Annuler',
  close: 'Fermer',
  enterCodeTitle: 'Entrer le Code',
  enterCodeSubtitle:
    'Entrez le code gestionnaire (défini à l’inscription) ou le code employé. Sur le cloud (Pages) : si le code n’est pas encore en base, le premier code saisi devient le code manager.',
  codeLabel: 'Code',
  codePlaceholder: 'Code manager (pas le mot de passe de connexion)',
  verifying: 'Vérification...',
  systemLocked: 'Système Verrouillé',
  loginBtn: 'Connexion',
  managerRole: 'Gestionnaire',
  workerRole: 'Travailleur',
  backToLogin: 'Retour à l\'accueil',
  logoutToBusinessLogin: 'Retour à l\'accueil',
  codeRequiredHint: 'Code manager ou employé requis (différent du mot de passe de compte).'
};

export const codeEntryModalAr = {
  errCodeRequired: 'يرجى إدخال الكود',
  errInvalidCode: 'كود غير صحيح',
  errUnlockCodeRequired: 'يرجى إدخال رمز إلغاء القفل',
  errBusinessId: 'لا يمكن تحديد معرف العمل',
  successUnlock: 'تم إلغاء القفل بنجاح',
  errInvalidUnlockCode: 'رمز إلغاء القفل غير صحيح',
  errUnlockValidation: 'حدث خطأ أثناء التحقق من رمز إلغاء القفل',
  lockoutTitle: 'النظام محظور',
  lockoutMessage: 'تم حظر النظام بسبب محاولات دخول فاشلة متعددة',
  timeRemaining: 'الوقت المتبقي',
  failedAttempts: 'تم إدخال {{count}} محاولات خاطئة',
  emergencyUnlockTitle: 'رمز الطوارئ لإلغاء القفل',
  emergencyUnlockHint: 'إذا كان لديك رمز الطوارئ، يمكنك استخدامه لإلغاء القفل',
  enterEmergencyCode: 'إدخال رمز الطوارئ',
  emergencyCodePlaceholder: 'أدخل رمز الطوارئ',
  validating: 'جاري التحقق...',
  unlockBtn: 'إلغاء القفل',
  cancel: 'إلغاء',
  close: 'إغلاق',
  enterCodeTitle: 'إدخال الكود',
  enterCodeSubtitle:
    'أدخل كود المدير (من التسجيل) أو كود الموظف. على السحابة (Pages): إن لم يكن الكود في القاعدة بعد، يصبح أول كود تُدخله كود المدير.',
  codeLabel: 'الكود',
  codePlaceholder: 'كود المدير (ليس كلمة مرور الحساب)',
  verifying: 'جاري التحقق...',
  systemLocked: 'النظام محظور',
  loginBtn: 'دخول',
  managerRole: 'المدير',
  workerRole: 'العامل',
  backToLogin: 'العودة إلى الصفحة الرئيسية',
  logoutToBusinessLogin: 'العودة إلى الصفحة الرئيسية',
  codeRequiredHint: 'يلزم كود المدير أو الموظف (مختلف عن كلمة مرور الحساب).'
};
